import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import Katie from "../../actors/characters/katie";
import OldMan from "../../actors/characters/oldMan";
import BigBen from "../../actors/characters/bigBen";
import { playerState } from "../../state/stateManager";
import OldLady from "../../actors/characters/oldLady";
import BigBensCommerce from "../bigBensCommerce";
import FarmerJackson from "../../actors/characters/farmerJackson";

export default class BigBens extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    this.bigBen = new BigBen({ x: 15 * 16, y: 12 * 16 });
  }
  onInitialize(engine) {
    engine.add("bigBensCommerce", BigBensCommerce);
    Resources.BigBensMap.addToScene(this);

    console.log("mccartys: adding player: ", this.player);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.bigBen);
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(17 * 16, 20 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 67 * 16, y: 33 * 16, direction: "down" });
      },
    });
    this.add(this.door);

    this.interactBarrier = new ex.Trigger({
      pos: new ex.Vector(11 * 16, 15 * 16 + 8),
      width: 160,
      height: 18,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        this.bigBen.startInteraction(this.player.lastDir, this.player);
      },
    });
    this.add(this.interactBarrier);
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    if (content.npcLocations.margie.location == 2) {
      this.margie = new OldLady({ x: 22 * 16 + 8, y: 10 * 16 + 8 }, "bigBens");

      this.margie.z = 6;
      this.add(this.margie);
      this.margie.graphics.use("leftIdle");
    }
    if (content.npcLocations.jackson.location == 2) {
      this.jackson = new FarmerJackson(
        { x: 10 * 16 + 11, y: 12 * 16 },
        "bigBens"
      );
      this.jackson.z = 6;
      this.add(this.jackson);
      this.jackson.graphics.use("rightIdle");
    }
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
  }
}
